import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import {
  vimeoBiz4BizUrl,
  vimeoUrl,
  youtubeUrl,
} from "components/utils/network/endpoints";

const HarbourClubPromotion: React.FC = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const via = urlParams.get("via");

  const isHarbour = via === "harbour";
  const isBiz4Biz = via === "biz4biz";

  const shouldShowPromotion = isHarbour || isBiz4Biz;

  const [playing, setPlaying] = useState(false);
  const [volume, setVolume] = useState(0);
  const [muted, setMuted] = useState(true);
  const [startedWatching, setStartedWatching] = useState(false);
  const [watchedIntro, setWatchedIntro] = useState<any>(
    localStorage.getItem("watchedIntro")
  );

  const handleIntroWatched = () => {
    setTimeout(() => {
      setWatchedIntro(true);
    }, 3000);
  };

  const handleDismissClick = () => {
    setWatchedIntro(true);
    setPlaying(false);
  };

  const handlePauseClick = () => {
    setPlaying(false);
    setVolume(0);
    setMuted(true);
  };

  const handlePlayClick = () => {
    setPlaying(true);
    setVolume(1);
    setMuted(false);
    setStartedWatching(true);
  };

  useEffect(() => {
    if (watchedIntro) {
      localStorage.setItem("watchedIntro", "true");
    }
  }, [watchedIntro]);

  if (watchedIntro || !shouldShowPromotion) {
    return null;
  }

  return (
    <div className="cursor-pointer z-50 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex justify-center items-center">
      <ReactPlayer
        className="overflow-hidden rounded-xl border-8"
        playing={playing}
        url={isBiz4Biz ? vimeoBiz4BizUrl : isHarbour ? youtubeUrl : vimeoUrl}
        width="640px"
        height="368px"
        title="BizCrunch intro video"
        autoPlay
        controls={true}
        muted={muted}
        volume={volume}
        onEnded={handleIntroWatched}
        onPlay={handlePlayClick}
        onPause={handlePauseClick}
      />

      {startedWatching && (
        <div
          className="absolute top-0 left-0 w-10 h-10 p-2 bg-gray-200 rounded-full"
          onClick={handleDismissClick}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      )}
    </div>
  );
};

export default HarbourClubPromotion;
